/* global BX */

(function () {
    'use strict';

    const CAPTCHA_SCRIPT_SRC = 'https://smartcaptcha.yandexcloud.net/captcha.js';
    let captchaScriptLoading = false;

    const FormUtils = {
        setupPhoneMask(input) {
            if (!input) return;

            input.addEventListener('input', function () {
                let value = this.value.replace(/\D/g, '');

                if (value.startsWith('7') || value.startsWith('8')) {
                    value = value.slice(1);
                }

                if (value.length > 10) value = value.slice(0, 10);

                let formatted = '';

                if (value.length > 0) {
                    formatted = '+7';
                    formatted += ' (' + value.slice(0, 3);
                }

                if (value.length >= 4) {
                    formatted += ') ' + value.slice(3, 6);
                }

                if (value.length >= 7) {
                    formatted += '-' + value.slice(6, 8);
                }

                if (value.length >= 9) {
                    formatted += '-' + value.slice(8, 10);
                }

                this.value = formatted;
            });

            input.addEventListener('keydown', function (e) {
                if (e.key === 'Backspace' && this.value.length <= 4) {
                    this.value = '';
                }
            });
        },

        validateRequired(value) {
            return typeof value === 'string' && value.trim() !== '';
        },
        validateEmail(value) {
            return /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/.test(value.trim());
        },
        validatePhoneDigits(digits) {
            return digits.length >= 10;
        },

        initCaptcha(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            if (window.smartCaptcha) {
                try {
                    window.smartCaptcha.reset();
                } catch (e) {
                    // ignore
                }
                return;
            }

            if (!captchaScriptLoading && !document.querySelector(`script[src*="smartcaptcha.yandexcloud.net"]`)) {
                window.onloadSmartCaptcha = () => {
                    if (window.smartCaptcha) {
                        window.smartCaptcha.render(containerId, {
                            sitekey: container.getAttribute('data-sitekey'),
                            style: 'adaptive',
                        });
                    }
                };

                const script = document.createElement('script');
                script.src = CAPTCHA_SCRIPT_SRC + '?onload=onloadSmartCaptcha';
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
                captchaScriptLoading = true;
            }
        },

        resetCaptcha() {
            if (window.smartCaptcha) {
                try {
                    window.smartCaptcha.reset();
                } catch (e) {
                    // ignore
                }
            }
        },

        showCommonError(block, text) {
            if (!block) return;
            block.innerHTML = text;
            block.style.display = 'flex';
        },
        hideCommonError(block) {
            if (!block) return;
            block.style.display = 'none';
            block.innerHTML = '';
        },
        clearFieldErrors(containerSelector = '') {
            const groups = document.querySelectorAll(
                (containerSelector ? containerSelector + ' ' : '') +
                    '.form-content__group.error, .form-content__file-wrapper.error'
            );
            groups.forEach((group) => {
                group.classList.remove('error');
                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = '';
            });
        },
        showFieldError(field, message) {
            if (!field) return;

            const group = field.closest('.form-content__group') || field.closest('.form-content__file-wrapper');
            if (group) {
                group.classList.add('error');
                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = message;
            }
        },
        clearFieldError(field) {
            if (!field) return;

            const group = field.closest('.form-content__group') || field.closest('.form-content__file-wrapper');
            if (group) {
                group.classList.remove('error');

                const errSpan = group.querySelector('.form-content__error');
                if (errSpan) errSpan.innerText = '';
            }
        },
        scrollToFirstError(containerSelector, commonErrorsBlock) {
            const firstError = document.querySelector(
                (containerSelector ? containerSelector + ' ' : '') +
                    '.form-content__group.error, .form-content__file-wrapper.error'
            );
            if (firstError) {
                firstError.scrollIntoView({behavior: 'smooth', block: 'center'});
            } else if (commonErrorsBlock && commonErrorsBlock.style.display === 'flex') {
                commonErrorsBlock.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        },

        setupFileButton(button, input, textElement) {
            if (!button || !input || !textElement) return;
            button.addEventListener('click', () => input.click());
            input.addEventListener('change', function () {
                textElement.textContent = this.files.length > 0 ? this.files[0].name : 'ничего не выбрано';
            });
        },

        async sendFormData({
            url,
            payload = {},
            files = [],
            headers = {},
            submitBtn,
            commonErrorsBlock,
            containerSelector,
            onSuccess,
            onFieldError,
        }) {
            let body;
            let isFormData = files.length > 0;
            if (isFormData) {
                const fd = new FormData();
                for (const key in payload) fd.append(key, payload[key]);
                files.forEach(({fieldName, fileInputElement}) => {
                    if (fileInputElement && fileInputElement.files.length > 0) {
                        fd.append(fieldName, fileInputElement.files[0]);
                    }
                });
                body = fd;
            } else {
                body = JSON.stringify(payload);
                headers['Content-Type'] = 'application/json';
            }

            headers['X-Requested-With'] = 'XMLHttpRequest';
            headers['Session-Id'] = BX.bitrix_sessid();

            if (submitBtn) submitBtn.disabled = true;

            try {
                const response = await fetch(url, {method: 'POST', headers, body});
                const result = await response.json();

                if (result.success) {
                    if (onSuccess) onSuccess(result);
                } else {
                    FormUtils.hideCommonError(commonErrorsBlock);
                    FormUtils.clearFieldErrors(containerSelector);
                    let handled = false;
                    if (result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
                        result.errors.forEach((err) => {
                            if (onFieldError) {
                                onFieldError(err.field, err.message);
                            }
                        });
                        handled = true;
                    }
                    if (!handled && result.message) {
                        FormUtils.showCommonError(commonErrorsBlock, result.message);
                    } else if (!handled) {
                        FormUtils.showCommonError(commonErrorsBlock, 'Произошла ошибка. Попробуйте позже.');
                    }
                    FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
                    const shouldResetCaptcha = result?.errors?.some(
                        (e) => e.field === 'smart_token' || e.field === 'captcha'
                    );
                    if (shouldResetCaptcha) {
                        FormUtils.resetCaptcha();
                    }
                }
            } catch (error) {
                console.error(error);
                FormUtils.showCommonError(commonErrorsBlock, 'Ошибка сети. Проверьте соединение и попробуйте снова.');
            } finally {
                if (submitBtn) submitBtn.disabled = false;
            }
        },

        createModal({modalId, closeBtnId, openBtnClass, openBtnSelector, onOpen, onClose}) {
            const modal = document.getElementById(modalId);
            if (!modal) return;

            const closeBtn = document.getElementById(closeBtnId);
            if (closeBtn) closeBtn.addEventListener('click', onClose);

            if (openBtnClass) {
                document.querySelectorAll(openBtnClass).forEach((btn) => {
                    if (btn) {
                        btn.addEventListener('click', (e) => {
                            e.preventDefault();
                            onOpen();
                        });
                    }
                });
            } else if (openBtnSelector) {
                document.querySelectorAll(openBtnSelector).forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        onOpen(btn);
                    });
                });
            }

            modal.style.display = 'none';
        },
    };

    window.FormUtils = FormUtils;
})();
